import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useState, useEffect } from "react";
import "./Style.css";
import { toast } from "react-toastify";
import axiosInstance from "../../../../hooks/axiosInstance";

export default function EditGroup({
  showEdit,
  closeModal,
  refreshPage,
  currentGroup,
}) {
  const [validationError, setValidationError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
  });

  const resetForm = () => {
    setFormData({
      name: "",
    });
    setValidationError({});
  };

  const handleChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClose = () => {
    resetForm();
    closeModal();
    refreshPage();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.post("/user/simple_code/edit", formData);
      toast.success("category updated successfully!");

      // refreshPage(); // Refresh the page or data as needed
    } catch (error) {
      console.error("Error submitting form:", error);
      if (error.response && error.response.data.errors) {
        setValidationError(error.response.data.errors);
        toast.error("Failed to save.");
      }
    } finally {
      setIsLoading(false);
    }
    setIsLoading(true);
    // Simulated successful submission
    handleClose();
    setIsLoading(false);
  };
  useEffect(() => {
    if (currentGroup) {
      // setData({
      //   category_name: currentGroup?.name || "",
      //   sub_category: currentGroup?.sub_categories || [],
      // });
      setFormData({
        id: currentGroup?.id,
        name: currentGroup?.name,
      });
    }
  }, [currentGroup]);

  return (
    <div className="CreateCSP">
      <Modal show={showEdit} onHide={handleClose} dialogClassName="modal-md">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <div>
                <h6>Name</h6>
              </div>
              <Form.Control
                type="text"
                placeholder="Enter..."
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
              {validationError.creditLine && (
                <small className="text-danger my-1">
                  {validationError.name[0]}
                </small>
              )}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className=""
              style={{
                backgroundColor: "#c4281b",
                color: "#fff",
                border: "none",
              }}
              type="submit"
            >
              Save
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}
